/**
 * Игроки события матча из GraphQL-ответа — в том порядке, в каком их принимает запись:
 * `[userId, secondaryUserId]` из `upsertMatch`.
 *
 * У гола с ассистом запись и чтение бэкенда расходятся (проверено на тестовом стенде по
 * `championshipStatsByPlayer`):
 * - запись: `userId` — пасующий, `secondaryUserId` — забивающий;
 * - чтение `goal`: `user` — **забивающий**, `secondaryUser` — пасующий.
 *
 * У остальных типов (замена, пенальти, угловой…) пара читается так же, как записана. Не
 * развернув гол при чтении, фронт при каждом пересохранении матча менял автора паса и автора
 * гола местами. Отсюда же контракт `MatchEvent.players` трансляции — `[пасующий, забивающий]`.
 */
export function readBackendMatchEventPlayerIds(
  type: string | null | undefined,
  userId: number | undefined,
  secondaryUserId: number | undefined,
): [number | undefined, number | undefined] {
  const isGoalWithAssist = type?.toLowerCase() === 'goal' && Boolean(userId) && Boolean(secondaryUserId);

  return isGoalWithAssist ? [secondaryUserId, userId] : [userId, secondaryUserId];
}
